import { Build, Component, Element, h, Host, Prop } from "@stencil/core";
import 'prismjs';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-typescript';

@Component({
    tag: 'app-code',
    shadow: true
})
export class AppCodeComponent {

    @Element() element!: HTMLElement;
    @Prop() language?: string;

    content?: string;
    style?: string;

    async componentWillRender() {
        this.style = (await import('./component.css')).default;

        const g = (Build.isBrowser ? globalThis : global) as any;

        const code = (this.element.textContent ?? 'no code').trim();
        this.element.textContent = '';

        this.content = g.Prism.highlight(
            code,
            g.Prism.languages[this.language!] ?? g.Prism.languages['plaintext'],
            this.language ?? 'plaintext'
        );
    }

    render() {
        return <Host>
            <style>{this.style}</style>
            <p class="header">
                <span class="title">{this.element.title}</span>
                <span class="language">{this.language}</span>
            </p>
            <pre
                innerHTML={this.content}
            ></pre>
        </Host>;
    }
}